import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { STATUS } from '../../utils/status';
import { TestAttemptsState } from '../interfaces/interface';
import { getExpertTestAttempts, getExpertTestAttemptsDownload, getTestAnalysis, getTestAttempts, getTestAttemptsDownload } from '../slices/testAttempts';

const ExtraReducers = (builder: ActionReducerMapBuilder<TestAttemptsState>) => {
  builder
    .addCase(getTestAttempts.pending, (state) => {
      state.getTestAttemptsStatus = STATUS.PENDING;
    })
    .addCase(getTestAttempts.fulfilled, (state, action: PayloadAction<any>) => {
      state.testAttempts = action.payload; 
      state.getTestAttemptsStatus = STATUS.SUCESS; 
    })
    .addCase(getTestAttempts.rejected, (state, action) => { 
      state.getTestAttemptsStatus = STATUS.FAILED;
    })
    .addCase(getExpertTestAttempts.pending, (state) => {
      state.getExpertTestAttemptStatus = STATUS.PENDING;
    })
    .addCase(getExpertTestAttempts.fulfilled, (state, action: PayloadAction<any>) => {
      state.testAttemptsExpert = action.payload; 
      state.getExpertTestAttemptStatus = STATUS.SUCESS; 
    })
    .addCase(getExpertTestAttempts.rejected, (state, action) => { 
      state.getExpertTestAttemptStatus = STATUS.FAILED;
    })
    .addCase(getTestAnalysis.pending, (state) => {
      state.getTestAnalysisStatus = STATUS.PENDING;
    })
    .addCase(getTestAnalysis.fulfilled, (state, action: PayloadAction<any>) => {
      state.getTestAnalysisStatus = STATUS.SUCESS; 
      state.testAanalysis = action.payload; 
    })
    .addCase(getTestAnalysis.rejected, (state, action) => { 
      state.getTestAnalysisStatus = STATUS.FAILED;
    })
    .addCase(getTestAttemptsDownload.pending, (state) => {
      state.getTestAttemptsDownloadStatus = STATUS.PENDING;
    })
    .addCase(getTestAttemptsDownload.fulfilled, (state, action: PayloadAction<any>) => {
      state.getTestAttemptsDownloadStatus = STATUS.SUCESS; 
      state.attemptsExpertDownload = action.payload;
      state.getTestAttemptsDownloadMessage = action.payload.message;
    })
    .addCase(getTestAttemptsDownload.rejected, (state, action: PayloadAction<any>) => { 
      state.getTestAttemptsDownloadStatus = STATUS.FAILED;
      state.getTestAttemptsDownloadMessage = action.payload.message;
    })
    .addCase(getExpertTestAttemptsDownload.pending, (state) => {
      state.getExpertTestAttemptsDownloadStatus = STATUS.PENDING;
    })
    .addCase(getExpertTestAttemptsDownload.fulfilled, (state, action: PayloadAction<any>) => {
      state.getExpertTestAttemptsDownloadStatus = STATUS.SUCESS; 
      state.expertTestAttemptsDownload = action.payload;
      state.getExpertTestAttemptsDownloadMessage = action.payload.message;
    })
    .addCase(getExpertTestAttemptsDownload.rejected, (state, action: PayloadAction<any>) => { 
      state.getExpertTestAttemptsDownloadStatus = STATUS.FAILED;
      state.getExpertTestAttemptsDownloadMessage = action.payload.message;
    })
};

export default ExtraReducers;
